export const FAVORITES = 'Favorites';
export const FAVORITE_STAR_COLOR = '#FFE78D';
export const FAVORITE_STAR_PRE_SELECTED_COLOR = '#7c838c';
export const REPORT_NAME_MAX_LENGTH = 100;
